export const CANVAS_BACKGROUND_COLOR = '#0000000d';
export const CHAR_COLOR = '#ffffffcc';
export const CHAR_TRACK_COLOR = '#0F0';
export const CHAR_SPEED_DEFAULT_VALUE = 10;
export const CHAR_SPEED_MIN_VALUE = 1;
export const CHAR_SPEED_DEFAULT_MAX_VALUE = 10;
export const CHAR_SPEED_MAX_AVAILABLE_VALUE = 10;

export const defaultSpeedChangeOptions = { intervalMs: 0 };
